import { ConsentHelper as ConsentHelperV2 } from './ConsentHubV2';
import stgConfig from "../../../config";
import storage from "../utils/storage";
import url from '../utils/url';
import axios from 'axios';
import Environment from './environment';
import AtlUrl from '../customer-experience/modules/atl-url';

const STAGING_ENDPOINT = `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}/endpoint`;
const environment = Environment.getEnvironment();
const BXP_EXPRESS_ENDPOINT = {
    [Environment.production()]: 'https://www.atlassian.com/endpoint',
    [Environment.staging()]: STAGING_ENDPOINT,
    [Environment.dev()]: STAGING_ENDPOINT,
};


export default class WebinarSignupFormWithConsentBigmarker {
    constructor(domRoot, params) {
        this.domRoot = domRoot;
        this.params = { ...params };

        this.form = this.domRoot.querySelector('.webinar-signup-component--form');
        this.countryDropdown = this.form.querySelector('#country');
        this.companySizeDropdown = this.form.querySelector('#company_size');
        this.region = this.form.querySelectorAll('.region');
        this.eventid = this.form.querySelector('#eventid');
        this.buttonSubmit = this.form.querySelector('[type="submit"]');
        this.consentHubPromise = null;
        this.isInGDPRLocal = false;
        this.webinarId = this.eventid.value;
        this.currLanguage = params.currLanguage;
        this.formLabels = params.formLabels;
        this.addCompanyName = params.addCompanyName;
  
        const queryParams = window.location.search.substring(1);
        if (queryParams.includes("utm_")) {
            this.utm_sfdc_campaign_id = this.getAndDecodeQueryParam('utm_sfdc-campaign_id');
            this.utm_source = this.getAndDecodeQueryParam('utm_source');
            this.utm_bmcr_source = this.getAndDecodeQueryParam('utm_bmcr_source');
            this.utm_medium = this.getAndDecodeQueryParam('utm_medium');  
            this.utm_campaign = this.getAndDecodeQueryParam('utm_campaign');  
            this.utm_content = this.getAndDecodeQueryParam('utm_content');  
        } else {
            try {
                const marketingContext = localStorage.getItem("marketingContext");
                const parsedMarketingContext = marketingContext ? JSON.parse(marketingContext) : null;
                const utms = parsedMarketingContext.utm;
                this.utm_sfdc_campaign_id = utms.sfdcCampaignId;
                this.utm_source = utms.source;
                this.utm_medium = utms.medium;
                this.utm_campaign = utms.campaign;
                this.utm_content = utms.content;
              }
              catch (error) {
                console.error("Failed to get utms from local marketingContext", error);
              }
        }

        this.init();
    }

    async init() {
        this.form.onsubmit = (e) => {
            e.preventDefault();
            this.isFormSubmission(e);
        };
        this.consentHubPromise = await (new ConsentHelperV2(this.params, this.form)).configPromise;
        this.domRoot.addEventListener('load', () => {
            this.isInGDPRLocal = !this.form.querySelector('.gdpr-checkbox input[type="checkbox"]').checked;
        });
        this.countryDropdown.onchange = () => {
            this.isCountryDropdownChange();
        };
        this.companySizeDropdown.onchange = () => {
            this.isCompanySizeDropdownChange();
        };
        this.isSetWebinarId();
        this.setFieldValidity();
    }

    isFormSubmission(event) {
        const self = this;
        const emailHp = self.form.querySelector('#alternate_email'); 
       
        if (emailHp.value === "" && self.form.checkValidity()) {
            const formData = new FormData(event.target);
            const departmentObj = this.currLanguage == 'ja' ? {department: formData.get('std1')} : {};
            const companyNameObj = this.addCompanyName ? {company: formData.get('company')} : {};

            self.buttonSubmit.classList.add('loading', 'disabled');
            const bigMarkerParametersObject = {
                ...{
                    eventId: self.webinarId,
                    email: formData.get('email'),
                    firstName: formData.get('firstname'),
                    lastName: formData.get('lastname'),
                    job_title: formData.get('job_title'),
                    country: formData.get('country'),
                    company_size: formData.get('company_size'),
                    currLanguage: this.currLanguage,
                    addCompanyName: this.addCompanyName,
                    "utm_sfdc-campaign_id": this.utm_sfdc_campaign_id ?? '',
                    utm_source: this.utm_source ?? '',
                    utm_bmcr_source: this.utm_bmcr_source ?? '',
                    utm_medium: this.utm_medium ?? '',
                    utm_campaign: this.utm_campaign ?? '',
                    utm_content: this.utm_content ?? ''
                },
                ...departmentObj,
                ...companyNameObj
            };

            self.consentHubPromise?.then((consentHub: { submitForm: (arg0: () => void, arg1: () => void) => void; }) => {
                consentHub.submitForm(
                    () => (
                        axios
                            .post(`${BXP_EXPRESS_ENDPOINT[environment]}/webinarsignup/bigmarker`, bigMarkerParametersObject)
                            .then(
                                (response) => self.isSubmitSuccess(response, bigMarkerParametersObject),
                                (error) => self.isSubmitError()
                            )
                    ),
                    () => self.isSubmitError()
                );
              }).catch(() => {
                self.isSubmitError();
              });
        }
    }

    isSubmitSuccess(response, bigMarkerParametersObject) {
        const responseData = response.data;
        this.sendTrackingToGrowAnalytics('', bigMarkerParametersObject?.eventId);
        if (this.currLanguage === 'ja') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'JapanWebinarRegistration', id: bigMarkerParametersObject?.eventId });
        }
        if (this.params.saveCookie == "yes") {
            storage.setCookie(this.params.cookieKey, this.params.cookieValue, 60, 'lax');
        }
        if (responseData["conference_url"]){
            window.location.href = responseData["conference_url"];
        }
    }

    isSubmitError() {
        this.buttonSubmit.classList.remove('loading', 'disabled');
        if(this.domRoot.querySelectorAll('.error--server').length === 0) {
            const errorResponseMessage = document.createElement("div");
            errorResponseMessage.className = "error error--server";
            errorResponseMessage.innerHTML = `${this.params.serverError}`;
            this.form.after(errorResponseMessage);
        }
    }

    isCountryDropdownChange() {
        const optVal= this.countryDropdown.querySelector("option:checked").value;
        if(optVal) {
            this.countryDropdown.style.color = 'rgba(0, 0, 0, 1)';
        } else {
            this.countryDropdown.style.color = 'rgba(0, 0, 0, 0.5)';
        }
        const additionalParams = {
            forceShowConsentMessaging: !this.isInGDPRLocal && this.isCountrySelectedGDPR(optVal),
            isAllowSetCustomLocale: !this.isInGDPRLocal,
            selectedLocale: this.params.gDPRCountries[optVal]
        };
        this.params = { ...this.params, ...additionalParams };

        this.form.querySelector('.gdpr-checkbox').remove();
        this.consentHubPromise = (new ConsentHelperV2(this.params, this.form)).configPromise;
    }

    isCompanySizeDropdownChange() {
        const optVal= this.companySizeDropdown.querySelector("option:checked").value;
        if(optVal) {
            this.companySizeDropdown.style.color = 'rgba(0, 0, 0, 1)';
        } else {
            this.companySizeDropdown.style.color = 'rgba(0, 0, 0, 0.5)';
        }
    }

    isCountrySelectedGDPR(optVal) {
        const listOfGDPRCountries = Object.keys(this.params.gDPRCountries);
        return listOfGDPRCountries.includes(optVal);
    }

    updatePartnerRef() {
        var urlParams = url.getUrlParams() || {};
        var param = urlParams["partnerref"] || false;
    
        if (param) {
            this.domRoot.querySelector('#partnerref').setAttribute("value", param);
        }
    }

    sendTrackingToGrowAnalytics(webinarKey, eventId){
        if(window.GROW){
          const tracking = new window.GROW.Analytics('SCI');
          tracking.send('bigmarker_form_complete', {'webinar_key': webinarKey, 'event_id': eventId});
        }
    }

    isSetWebinarId() {
        if(this.region.length > 0) {
            this.region.forEach(domElement => {
                domElement.onchange = (e) => {
                    this.eventid.setAttribute('value', e.target.value);
                    this.webinarId = this.eventid.value;
                };
            });
            this.eventid.setAttribute('value', this.region[0].getAttribute('value'));
        }
        this.webinarId = this.eventid.value;
    } 

    setFieldValidity() {
        const rules = {
            email: {
              required: true,
              email: true
            },
            firstname: {
              required: true
            },
            lastname: {
              required: true
            },
            // job_title
            title: {
              required: true
            },
            country: {
              required: true
            },
            company_size: {
              required: true
            }
        };
      
        if (this.currLanguage === 'ja') {
            rules.std1 = {
                required: true
            }
        }
        if (this.addCompanyName) {
            rules.company = {
                required: true
            }
        }

        Object.keys(rules).forEach((rule) => {
            const ruleElement = this.form.querySelector(`#${rule}`);
            if(ruleElement) {
                ruleElement.setAttribute("required", "required");
                ruleElement.addEventListener('invalid', (event) => {
                    this.messageError(event);
                });
                ["keyup", "change"].forEach(eventType => {
                    ruleElement.addEventListener(eventType, (event) => {
                      this.clearError(event);
                    });
                });
            }
        });
    }

    messageError(event: Event) {
        const errMessages = {
            firstname: this.formLabels.required,
            lastname: this.formLabels.required,
            country: this.formLabels.required,
            std1: this.formLabels.required,
            title: this.formLabels.missingJob,
            company: this.formLabels.missingCompany,
            company_size: this.formLabels.required,
            email: this.formLabels.invalidEmail
        };

        if (event.target) {    
          let fieldIdentifier = event.target.id;
          let errorMessageText = errMessages[fieldIdentifier];
          this.addErrorLabel(fieldIdentifier, errorMessageText)
        }
    }

    clearError(event) {
        let allFields = [event.target];
        const plainRegex = /select|radio|checkbox/;
    
        if (event.target.type.match(plainRegex)) {
          allFields = document.querySelectorAll(`[name="${event.target.name}"]`)
        }
        allFields.forEach(field => {
          let fieldIdentifier = field.type.match(plainRegex) ? field.name : field.id;
          const fieldParent = document.getElementById(`${fieldIdentifier}`)?.parentElement as HTMLElement;
          let fieldError = fieldParent.querySelector(`#${fieldIdentifier}-error`);
          if (fieldError) {
            fieldParent.removeChild(fieldError);
          }
        });
    }

    addErrorLabel(elementId: string, errMessage: string) {
        const targetElement = this.domRoot.querySelector(`#${elementId}`).parentElement;
        const isContainErrorLabel = targetElement.querySelector(`#${elementId}-error`);
        if(!isContainErrorLabel && errMessage) {
            const errorLabelElement = document.createElement("label");
            const errorLabelText = document.createTextNode(errMessage);
            errorLabelElement.appendChild(errorLabelText);
            errorLabelElement.setAttribute("id", `${elementId}-error`);
            errorLabelElement.setAttribute("class", "error");
            errorLabelElement.setAttribute("for", `${elementId}`);
            targetElement.appendChild(errorLabelElement);
        }
    }

    getAndDecodeQueryParam(expectedParameter: string) {
        const parameterValue = AtlUrl.getParameter(expectedParameter);
        if (parameterValue) {
            const decodedParameterValue = decodeURIComponent(parameterValue);
            return decodedParameterValue;
        }
        return parameterValue;
    }
}